import React from 'react'
import { Select } from 'antd'
import { SelectProps } from 'antd/lib/select'
import { LabeledValue } from 'antd/lib/tree-select'
import { CustomerTypeEnum, useQueryCustomers } from '../../../api'

const { Option } = Select

type Props = SelectProps<LabeledValue | LabeledValue[] | string> & {
  /**
   * #7806 — optional customer-type filter, passed straight through to the `customers` query.
   * Destructured with NO DEFAULT on purpose: absent ⇒ `undefined` ⇒ the key is dropped from the
   * serialised variables, so the two shipped consumers send a byte-identical wire and keep the
   * server's own `serviceProvider` default. `null` is passed through for an "all types" consumer.
   * Locked by CustomersSelector.test.tsx CS1 (the absent-prop lock).
   */
  type?: CustomerTypeEnum | null
}

export const CustomersSelector: React.FC<Props> = ({ searchValue, type, ...props }) => {
  const { data, loading } = useQueryCustomers({ variables: { input: { searchText: searchValue, type } } })
  const customers = (data && data.customers) || []
  return (
    <Select filterOption={false} labelInValue {...props} loading={loading}>
      {customers.map(customer => (
        <Option title={customer.name} key={customer.id} value={customer.id}>
          {customer.name}
        </Option>
      ))}
    </Select>
  )
}
